export default "__VITE_ASSET__c0fc867f__"